import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Select, Spin } from 'antd';
import { connect } from 'react-redux';
import { getPosts, getPostCats, getCatPosts } from '../../../../core/actions/postGet';
import Footer from '../../components/footer/footer';
import PostCard from '../../components/blog/postcard'
import moment from 'moment';
import Banner from '../../components/blog/banner'
import OurBlog from '../../components/blog/ourblog'
const { Option } = Select;
const { Meta } = Card;

class Blog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      theposition: '',
      posts: [],
      postcats: [],
      floatSelect: false,
      recentNews: [],
      catPosts: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const { posts, postcats,fetchPostsSuccess, catPosts } = nextProps;
    if (this.state.posts.length === 0 && fetchPostsSuccess) {
      this.setState({
        posts
      })
    }
    if (postcats.length > 0) {
      this.setState({
        postcats
      })
    }
    this.setState({
      catPosts
    })
  }

  componentDidMount() {
    // console.warn(this.props)
    const { posts, postcats } = this.state
    if (!posts.length) {
      this.props.getPosts()
    }
    if (!postcats.length) {
      this.props.getPostCats()
    }
    // window.addEventListener('scroll', this.listenToScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }

  handleSelectChange = (value) => {
    this.props.history.push(`/blog/category/${value}`)
  }

  listenToScroll = () => {
    var catHeight = document.getElementById('catSelect').offsetTop

    // console.log(`cat height is ${catHeight}`)

    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    // const height =
    //   document.documentElement.scrollHeight -
    //   document.documentElement.clientHeight

    if (winScroll >= catHeight) {
      // console.log('float it')
      this.setState({
        floatSelect: true
      })
    } else {
      this.setState({
        floatSelect: false
      })
    }

    // this.setState({
    //   theposition: scrolled,
    // }, () => {
    //   console.log(this.state.theposition)
    // })
  }

  gotoPost = (slug) => {
    this.props.history.push(`/blog/${slug}`)
  }


  render() {
    const { posts, postcats, floatSelect, catPosts } = this.state
    // let floatingSelect = floatSelect ? 'floatselect' : ''
    // let loading = !posts.length > 0;
    return (
      this.props.fetchPostsSuccess ?
        <div className="x-main-blog">
          <TopNav />
          <Banner />
          <OurBlog 
          fetchPostsSuccess={this.props.fetchPostsSuccess}
          posts={posts} 
          postcats={postcats} getCatPosts={this.props.getCatPosts} catPosts={catPosts}
          clearCatPosts={this.clearCatPosts}
          />
          <Footer />
        </div>
        :
        <div className="x-loader">
          <Icon type="loading" style={{ fontSize: 60 }} spin />
        </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getPosts: () => dispatch(getPosts()),
  getPostCats: () => dispatch(getPostCats()),
  getCatPosts: (slug) => dispatch(getCatPosts(slug)),
});

const mapStateToProps = state => ({
  firebase: state.firebase,
  posts: state.allPosts.posts,
  fetchPostsSuccess: state.allPosts.fetchPostsSuccess,
  profile: state.firebase.profile,
  postcats: state.allPosts.postcats,
  catPosts: state.allPosts.catPosts,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Blog);